const actionOpenUrlSchema = [
  {
    type: 'url',
    name: 'url',
    label: 'Link',
    events: ['input'],
    validation: 'url',
  },
  {
    type: 'range',
    name: 'height_percentage',
    label: 'Browser Height Ratio',
    validation: 'required|max:1|min:0',
    min: '0',
    max: '1',
    step: 0.01,
    events: ['input'],
    showValue: true,
    help: '1 for fullscreen, 0.5 for half-screen',
  },
  {
    type: 'checkbox',
    name: 'show_overlay_controls',
    help: 'If checked, shows a close button and resize bar',
    label: 'Show Browser Controls',
    events: ['input'],
  },
  {
    type: 'checkbox',
    name: 'is_fullscreen',
    help: 'If checked, opens the page in a fullscreen external browser (incl. cookies support)',
    label: 'Use External Browser',
    events: ['input'],
  },
]

const actionOpenUrlValue = {
  type: 'action_open_url',
  height_percentage: 0.5,
  url: 'https://hoverlay.com',
  wait_until_finished: true,
  show_overlay_controls: true
}

export { actionOpenUrlSchema, actionOpenUrlValue }
